interface IContainerProps {
    center?: boolean;
    between?: boolean;
    relative?: boolean;
    fullHeight?: boolean;
    fullWidth?: boolean;
    maxWidth?: number;
    bgPrimary?: boolean;
    hiddenMobile?: boolean;
    flexColumn?: boolean;
    padding?: string;
    wrap?: boolean;
    wrapResponsive?: boolean;
    cardResponsive?: boolean;
    paddingHorizontal?: string;
    paddingVertical?: string;
    marginVertical?: string;
    marginHorizontal?: string;
    itemsCenter?: boolean;
    className?: string;
    gap?: number;
    children: React.ReactNode;
    style?: React.CSSProperties;
}

export default function Container(
    { 
        children, 
        center, 
        between, 
        fullHeight, 
        fullWidth, 
        maxWidth,
        bgPrimary, 
        hiddenMobile,
        flexColumn,
        padding,
        wrap,
        wrapResponsive,
        cardResponsive,
        paddingHorizontal,
        paddingVertical,
        marginVertical,
        marginHorizontal,
        itemsCenter,
        relative,
        gap,
        className = "",
        style
    }: IContainerProps
) {
    const classes = `
        flex 
        ${relative ? "relative" : ""}
        ${padding ? `p-${padding}` : ""}
        ${paddingVertical ? `py-${paddingVertical}` : ""}
        ${paddingHorizontal ? `px-${paddingHorizontal}` : ""}
        ${marginVertical ? `my-${marginVertical}` : ""}
        ${marginHorizontal ? `mx-${marginHorizontal}` : ""}
        ${flexColumn ? "flex-column" : ""}
        ${center ? "justify-content-center align-items-center" : ""} 
        ${between ? "justify-content-between align-items-center" : ""}
        ${itemsCenter ? "align-items-center" : ""}
        ${fullHeight ? "h-screen" : ""} 
        ${fullWidth ? "w-full" : ""} 
        ${bgPrimary ? "bg-primary" : ""}
        ${hiddenMobile ? "container--hidden-mobile": ""}
        ${gap ? `gap-${gap}` : ""} ${className}
        ${wrap ? "flex-wrap": ""}
        ${wrapResponsive ? "wrap-responsive": ""}
        ${cardResponsive ? "card-responsive": ""}
    `;

    return (
        <div 
            className={classes.replace(/\s+/g,' ').trim()}
            style={maxWidth ? { maxWidth: `${maxWidth}px`, ...style } : {...style}}
        >
            { children }
        </div>
    )
}
